import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { NxiNavigationModule } from '@pershing/nxi-navigation';
import { PortalComponentsModule } from '@pershing/nxi-portalcomponents';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { NxiPortalCoreModule } from '@pershing/nxi-core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NxiCommonModule } from '@pershing/nxi-common';
import { PershingCoreRootModule, PermissionCheckerService, IAuthorizationService } from '@pershing/pershing-core';
import { MCVModule } from '@pershing/nxi-ng-portfolio';
import { registerLocaleData } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { EDCEDeliveryModule } from '@pershing/edc-edelivery';
import { NxiModernNavigationModule } from '@pershing/nxi-ng-modern-navigation';
import localeEs from '@angular/common/locales/es';
import { NxiPortalCommonModule, PortalAuthorizationServiceDefinition, PortalAppComponent } from '@pershing/nxi-ng-portal-common';
registerLocaleData(localeEs, 'es');

// For SiteBuilder trigger init with service definition for entitlements (instead of passed in appSettings)
export function initUserRoles(
    permissionCheckerService: PermissionCheckerService,
    portalAuthorizationServiceDefinition: PortalAuthorizationServiceDefinition): () => Promise<any> {
    if (window['appSettings'].isLoggedIn) {
        return () => permissionCheckerService.init(portalAuthorizationServiceDefinition);
    } else {
        return () => null;
    }
}

@NgModule({
        imports: [
            PershingCoreRootModule,
            NxiPortalCoreModule.forRoot(),
            NxiCommonModule,
            BrowserAnimationsModule,
            RouterModule,
            HttpClientModule,
            PortalComponentsModule,
            NxiNavigationModule,
            NgIdleKeepaliveModule.forRoot(),
            HttpClientJsonpModule,
            MCVModule,
            MatDialogModule,
            MatCardModule,
            EDCEDeliveryModule,
            NxiModernNavigationModule,
            NxiPortalCommonModule
        ],
        providers: [
            { provide: 'AppSettings', useValue: window['appSettings']  },
            { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { float: 'never' } },
            { provide: APP_INITIALIZER, useFactory: initUserRoles, multi: true, deps: [IAuthorizationService] }
        ],
        bootstrap: [PortalAppComponent]
    })
    export class PortalAppModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/tslint-loader!./~/source-map-loader!./projects/nxi-ng-portal/src/app/app.module.ts